export default __webpack_public_path__ + "assets/sounds/c4b1a274df1766298cb8388d30042b9e.mp3";